import { useState } from "react";
import { Modal, Divider, Button } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import config from "../../config";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
}));
const CreateExpenseType = ({ open, setOpen }) => {
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [expenseTypeName, setExpenseTypeName] = useState("");
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (expenseTypeName.length === 0) {
      return alert("Please enter the Expense Type");
    }
    const expensesType = shopDetails.expensesType.map((i) =>
      i.expensesTypeName.toLowerCase()
    );
    if (expensesType.includes(expenseTypeName.toLowerCase())) {
      return alert("Expenses Type is already exist");
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${config.newApiGateway}/expenses/addEditExpensesType`,
        {
          body: JSON.stringify({
            shopId: shopId,
            type: "add",
            expensesTypeName: expenseTypeName,
            employeeId: shopDetails.empId ? shopDetails.empId : "",
            ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
              parentShopId: shopDetails.ownerShopId,
            }),
          }),
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "content-type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.code === "SUCCESS") {
        alert(data.message);
        dispatch({
          type: "EXPENSES_TYPE",
          payload: data.data.Attributes.expensesType,
        });
      }
      if (data.code === "ERROR") {
        alert(data.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setExpenseTypeName("");
      setLoading(false);
      setOpen(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        footer={false}
        centered
        className={classes.modalStyle}
        width={700}
        onCancel={handleClose}
        onFinish={handleSubmit}
      >
        <h4
          style={{
            color: "#000000",
          }}
        >
          Create Expenses Type
        </h4>
        <Divider className={classes.dividerStyle} />
        <TextField
          id="customerNumber"
          size="small"
          label="Enter Expense Type"
          variant="outlined"
          value={expenseTypeName}
          onChange={(e) => setExpenseTypeName(e.target.value)}
          placeholder="Enter Expense Type"
          style={{
            margin: "1.5rem 0",
            width: "100%",
          }}
        />
        <Divider className={classes.dividerStyle} />
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
          }}
        >
          <Button
            style={{
              background: "#FFF",
              color: "#EF4667",
            }}
            onClick={handleClose}
            size="large"
          >
            Cancel
          </Button>
          <Button
            style={{
              background: "#EF4667",
              color: "#fff",
            }}
            onClick={handleSubmit}
            size="large"
            loading={loading}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CreateExpenseType;
